module.exports = __webpack_public_path__ + "static/media/Chris Blocher.852ee97f.png";